const TranslateDate = (dateValue: string, language:string) => {
  const enMonth = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const frMonth = [
    "janv",
    "févr",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "sept",
    "oct",
    "nov",
    "déc",
  ];

  const valueAsDate = new Date(dateValue);

  let month;
  switch (language) {
    case 'fr':
      month = frMonth[valueAsDate.getMonth()];
      break;
      case 'en':
      month = enMonth[valueAsDate.getMonth()];
      break;    
     default:
      month = enMonth[valueAsDate.getMonth()]; 
      break;

  }
  let day =
    valueAsDate.getDate().toString().length < 2
      ? `0${valueAsDate.getDate()}`
      : valueAsDate.getDate();
  day = day.toString().replace(/^0+/, ""); //remove leading zero

  switch (language) {
    case 'fr':
      return `${day} ${month} ${valueAsDate.getFullYear()}`;
    case 'en':
      return `${month} ${day},  ${valueAsDate.getFullYear()}`;
    default:
      return `${month} ${day},  ${valueAsDate.getFullYear()}`;
  } 

}
export default TranslateDate;
